export const companyIdOption = [
    {id: 1, label: 'Select', value: ''},
    {id: 2, label: 'ACN', value: 'ACN'},
    {id: 3, label: 'BN', value: 'BN'},
    {id: 4, label: 'CN', value: 'CN'},
    {id: 5, label: 'CPR', value: 'CPR'},
    {id: 6, label: 'CVR', value: 'CVR'},
    {id: 7, label: 'DIW', value: 'DIW'},
    {id: 8, label: 'KT', value: 'KT'},
    {id: 9, label: 'ORG', value: 'ORG'},
];
export const gstIdOption = [
    {id: 1, label: 'GST', value: 'GST'},
    {id: 2, label: 'ABN', value: 'ACN'},
    {id: 3, label: 'BN', value: 'BN'},
    {id: 4, label: 'CST', value: 'CN'},
    {id: 5, label: 'ORG', value: 'CPR'},
    {id: 6, label: 'TAX', value: 'CVR'},
    {id: 7, label: 'VST', value: 'DIW'},
];

export const industryType = [
    {id: 1, label: 'Select', value: ''},
    {id: 2, label: 'Agency or Sales House', value: 'Agency or Sales House'},
    {id: 3, label: 'Agriculture', value: 'Agriculture'},
    {id: 4, label: 'Art and Design', value: 'Art and Design'},
    {id: 5, label: 'Automotive', value: 'Automotive'},
    {id: 6, label: 'Construction', value: 'Construction'},
    {id: 7, label: 'Consulting', value: 'Consulting'},
    {id: 8, label: 'Consumer Packaged Goods', value: 'Consumer Packaged Goods'},
    {id: 9, label: 'Education', value: 'Education'},
    {id: 10, label: 'Engineering', value: 'Engineering'},
    {id: 11, label: 'Entertainment', value: 'Entertainment'},
    {id: 12, label: 'Financial Services', value: 'Financial Services'},
    {id: 13, label: 'Food Services (Restaurants/Fast Food)', value: 'Food Services (Restaurants/Fast Food)'},
    {id: 14, label: 'Gaming', value: 'Gaming'},
    {id: 15, label: 'Government', value: 'Government'},
    {id: 16, label: 'Health Care', value: 'Health Care'},
    {id: 17, label: 'Interior Design', value: 'Interior Design'},
    {id: 18, label: 'Internal', value: 'Internal'},
    {id: 19, label: 'Legal', value: 'Legal'},
    {id: 20, label: 'Manufacturing', value: 'Manufacturing'},
    {id: 21, label: 'Marketing', value: 'Marketing'},
    {id: 22, label: 'Mining and Logistics', value: 'Mining and Logistics'},
    {id: 23, label: 'Non-Profit', value: 'Non-Profit'},
    {id: 24, label: 'Publishing and Web Media', value: 'Publishing and Web Media'},
    {id: 25, label: 'Real Estate', value: 'Real Estate'},
    {id: 26, label: 'Retail (E-Commerce and Offline)', value: 'Retail (E-Commerce and Offline)'},
    {id: 27, label: 'Services', value: 'Services'},
    {id: 28, label: 'Technology', value: 'Technology'},
    {id: 29, label: 'Telecommunications', value: 'Telecommunications'},
    {id: 30, label: 'Travel/Hospitality', value: 'Travel/Hospitality'},
    {id: 31, label: 'Web Designing', value: 'Web Designing'},
    {id: 32, label: 'Web Development', value: 'Web Development'},
    {id: 33, label: 'Writers', value: 'Writers'},
];
